const config = {
    app: {
        name: "People",
    },
    session: {
        types: [
            'Kids',
            'Girls',
            'Boys',
            'Advance',
        ],
    },
};

export default config;